import { getProject } from "../api/generated/wrappers/project";
import { getProcess } from "../api/generated/wrappers/project";
import { getComment } from "../api/generated/wrappers/project";
import { getActivityLog } from "../api/generated/wrappers/project";
import { getProjectTrash } from "../api/generated/wrappers/project";
import { createQueryKeys } from "./create-query-keys";
const projectQueryKeys = createQueryKeys("project", {
    all: (projectCode) => ({
        queryKey: ["all", projectCode],
        queryFn: async () => await getProject(projectCode),
    }),
    process: (projectId) => ({
        queryKey: ["process", projectId],
        queryFn: async () => await getProcess(projectId),
    }),
    comment: (projectId) => ({
        queryKey: ["comment", projectId],
        queryFn: async () => await getComment(projectId),
    }),
    activity: (projectId) => ({
        queryKey: ["activity", projectId],
        queryFn: async () => await getActivityLog(projectId),
    }),
    trash: () => ({
        queryKey: ["trash"],
        queryFn: async () => await getProjectTrash(),
    }),
});
export default projectQueryKeys;
